import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalGeneric } from '../../../../ui/generics';
import { IDeliveryOrder } from '../../core/interfaces/IDeliveryOrder';

@Component({
    selector: 'app-order-change-log-modal',
    templateUrl: './order-change-log-modal.component.html',
    styleUrls: ['./order-change-log-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderChangeLogModalComponent extends ModalGeneric implements OnInit {

  public title = 'Änderungsprotokoll';
  public orderId: number;

  constructor(
    protected readonly cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  public ngOnInit(): void {
  }

  public showModal(order: IDeliveryOrder): void {
    super.showModal();
    this.orderId = order?.id;
    this.title = order?.id
      ? `Änderungsprotokoll Bestellung #${order.id}`
      : 'Änderungsprotokoll';
    this.cdr.markForCheck();
  }
}
